const e = {
  currencyPEN: {
    mask: Number,
    scale: 2,
    thousandsSeparator: ",",
    radix: ".",
    inputMode: "numeric"
  },
  currencyUSD: {
    mask: Number,
    scale: 2,
    thousandsSeparator: ",",
    radix: ".",
    inputMode: "numeric"
  }
};
export {
  e as maskTemplates
};
